// extracted by mini-css-extract-plugin
export default {"fixtureStatsHeader":"SingleFixtureNavigation_fixtureStatsHeader__WM+p4","activeStatBtn":"SingleFixtureNavigation_activeStatBtn__1dNwH"};